// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__J9js4","modalFooterButton":"ModalNotes_modalFooterButton__KdJiQ"};